<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="9"
    viewBox="0 0 6 9"
  >
    <path
      fill="none"
      fill-rule="evenodd"
      stroke="#FFF"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M-1 2L2.5 6 6 2"
      transform="rotate(-90 3 4)"
    />
  </svg>
</template>